import { DocFiltersDictionnary } from './property-bag-state.model';

export class PatchIsBatAction {
  static readonly type = '[PropertyBag] Patch Is Bat';
  constructor(public isBat: boolean) { }
}

export class PatchShowPopupWarningAction {
  static readonly type = '[PropertyBag] Patch ShowPopupWarning';
  constructor(public showPopupWarning: boolean) { }
}

export class PatchDocFiltersDictionnaryAction {
  static readonly type = '[PropertyBag] Patch DocFiltersDictionnary';
  constructor(public docFiltersDictionnary: DocFiltersDictionnary) { }
}
